var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.955,
    height: 20,
    viewBox: "0 0 19.955 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_68471",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 68471",
    transform: "translate(-0.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_57252",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 57252",
    d: "M269.07,4.376a9.51,9.51,0,0,0-1.208-.259l.2-1.35a10.882,10.882,0,0,1,1.382.3Z",
    transform: "translate(-255.94 -2.649)",
    fill: "#1891e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_57253",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 57253",
    d: "M17.028,19.882l-4.236-2.133a11.071,11.071,0,0,1-2.291.239c-5.007,0-9.978-3.695-9.978-8.994S5.494,0,10.5,0V1.364c-4.749,0-8.613,3.423-8.613,7.63s3.864,7.63,8.613,7.63a9.684,9.684,0,0,0,2.224-.257.682.682,0,0,1,.464.055l3.465,1.745V14.627a.682.682,0,0,1,.207-.49,7.15,7.15,0,0,0,2.254-5.143,7.66,7.66,0,0,0-4.993-6.925L14.64.808a9.091,9.091,0,0,1,5.839,8.186,8.469,8.469,0,0,1-2.461,5.915v4.364A.619.619,0,0,1,17.028,19.882Z",
    fill: "#1891e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_57254",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 57254",
    d: "M93.334,78.573a5.278,5.278,0,0,1-2.106-1.714l-.381-.528a1.274,1.274,0,0,1,.133-1.653l1.49-1.489a1.292,1.292,0,0,1,1.942.156l.516.715,3.193-3.192-.715-.515a1.292,1.292,0,0,1-.156-1.942l1.49-1.489a1.274,1.274,0,0,1,1.653-.133l.526.379a5.236,5.236,0,0,1,1.719,2.117,3.578,3.578,0,0,1-.732,3.943l-4.619,4.618A3.423,3.423,0,0,1,93.334,78.573Zm.565-1.242a2.19,2.19,0,0,0,2.422-.451l4.619-4.618a2.19,2.19,0,0,0,.45-2.424,3.87,3.87,0,0,0-1.271-1.565l-.467-.337L98.285,69.3l1.283.926a.689.689,0,0,1,.083,1.036l-4.326,4.325a.689.689,0,0,1-1.036-.083l-.926-1.283L92,75.592l.338.469a3.87,3.87,0,0,0,1.56,1.268l0,0Z",
    transform: "translate(-86.239 -63.708)",
    fill: "#1891e5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ed0fc635.svg";
export { ForwardRef as ReactComponent };